import React from "react";
import Filters from "../../components/filter/Filter";
import PurchasesTable from "../../components/purchases/PurchasesTable";

const Purchases = () => {
  return (
    <div className="flex flex-col space-y-10">
      <section>
        <Filters />
      </section>
      <section>
        <PurchasesTable />
      </section>
    </div>
  );
};

export default Purchases;
